__turbopack_context__.v({
  "active": "iKFlQq_active",
  "analyzedAt": "iKFlQq_analyzedAt",
  "backLink": "iKFlQq_backLink",
  "categoryBar": "iKFlQq_categoryBar",
  "categoryFill": "iKFlQq_categoryFill",
  "categoryLabel": "iKFlQq_categoryLabel",
  "categoryScore": "iKFlQq_categoryScore",
  "categoryScores": "iKFlQq_categoryScores",
  "categoryValue": "iKFlQq_categoryValue",
  "ctaButtons": "iKFlQq_ctaButtons",
  "ctaContent": "iKFlQq_ctaContent",
  "ctaSection": "iKFlQq_ctaSection",
  "expanded": "iKFlQq_expanded",
  "filled": "iKFlQq_filled",
  "gaugeContent": "iKFlQq_gaugeContent",
  "gaugeLabel": "iKFlQq_gaugeLabel",
  "gaugeProgress": "iKFlQq_gaugeProgress",
  "gaugeRing": "iKFlQq_gaugeRing",
  "gaugeScore": "iKFlQq_gaugeScore",
  "headerActions": "iKFlQq_headerActions",
  "headerLeft": "iKFlQq_headerLeft",
  "headerThumbnail": "iKFlQq_headerThumbnail",
  "headerThumbnailIcon": "iKFlQq_headerThumbnailIcon",
  "high": "iKFlQq_high",
  "issueBody": "iKFlQq_issueBody",
  "issueCard": "iKFlQq_issueCard",
  "issueCategory": "iKFlQq_issueCategory",
  "issueHeader": "iKFlQq_issueHeader",
  "issueHeaderContent": "iKFlQq_issueHeaderContent",
  "issueImpact": "iKFlQq_issueImpact",
  "issuePrinciple": "iKFlQq_issuePrinciple",
  "issueSection": "iKFlQq_issueSection",
  "issueTitle": "iKFlQq_issueTitle",
  "issueToggle": "iKFlQq_issueToggle",
  "issuesList": "iKFlQq_issuesList",
  "issuesSection": "iKFlQq_issuesSection",
  "low": "iKFlQq_low",
  "medium": "iKFlQq_medium",
  "overallScore": "iKFlQq_overallScore",
  "placeholderIcon": "iKFlQq_placeholderIcon",
  "placeholderSubtext": "iKFlQq_placeholderSubtext",
  "placeholderText": "iKFlQq_placeholderText",
  "principleDesc": "iKFlQq_principleDesc",
  "principleName": "iKFlQq_principleName",
  "prioritiesList": "iKFlQq_prioritiesList",
  "prioritiesSection": "iKFlQq_prioritiesSection",
  "prioritiesSub": "iKFlQq_prioritiesSub",
  "priorityBody": "iKFlQq_priorityBody",
  "priorityHead": "iKFlQq_priorityHead",
  "priorityItem": "iKFlQq_priorityItem",
  "priorityMeta": "iKFlQq_priorityMeta",
  "priorityRank": "iKFlQq_priorityRank",
  "priorityTitle": "iKFlQq_priorityTitle",
  "reportHeader": "iKFlQq_reportHeader",
  "reportPage": "iKFlQq_reportPage",
  "sampleNote": "iKFlQq_sampleNote",
  "scoreGauge": "iKFlQq_scoreGauge",
  "scoresSection": "iKFlQq_scoresSection",
  "screenshotImg": "iKFlQq_screenshotImg",
  "screenshotOverlay": "iKFlQq_screenshotOverlay",
  "screenshotPlaceholder": "iKFlQq_screenshotPlaceholder",
  "screenshotPlaceholderInner": "iKFlQq_screenshotPlaceholderInner",
  "screenshotSection": "iKFlQq_screenshotSection",
  "screenshotTitle": "iKFlQq_screenshotTitle",
  "screenshotWrapper": "iKFlQq_screenshotWrapper",
  "sectionTitle": "iKFlQq_sectionTitle",
  "severityBar": "iKFlQq_severityBar",
  "severityBars": "iKFlQq_severityBars",
  "severityIndicator": "iKFlQq_severityIndicator",
  "severityLabel": "iKFlQq_severityLabel",
  "siteInfo": "iKFlQq_siteInfo",
  "siteUrl": "iKFlQq_siteUrl",
  "stakeSection": "iKFlQq_stakeSection",
  "statLabel": "iKFlQq_statLabel",
  "statNumber": "iKFlQq_statNumber",
  "summarySection": "iKFlQq_summarySection",
  "summaryStat": "iKFlQq_summaryStat",
  "summaryStats": "iKFlQq_summaryStats",
});
